import {CrudService} from '../services/';

export const fetchCategoriesFavorites = (city_id) => {
    return CrudService._get({
        url: `segments/favorites/${city_id}`
    });
};

export const fetchCategories = (city_id) => {

    return CrudService._get({
        url: `segments/tree/${city_id}`,
    });
};

export const getCategory = (id, params = {}) => {

    return CrudService._get({
        url: `segments/${id}`,
        params
    });
};